import difference from 'lodash-es/difference'

export const searchCommonParams = [
  'term',
  'tags',
  'category',
  'platform',
  'hosting_setup',
  'compatible_with',
  'colors',
  'sizes',
  'sales',
  'rating_min',
  'price_min',
  'price_max',
  'poly_count',
  'file_formats',
  'item_type',
  'date',
  'length_min',
  'length_max',
  'tempo',
  'alpha',
  'vocals_in_audio',
  'looped',
  'orientation',
  'requires_plugins',
  'resolution_min',
  'frame_rate',
  'page',
  'attribute_key',
  'attribute_value',
  'username',
  'item_id',
  'include_pro_affiliated'
]

export const searchApiParams = searchCommonParams.concat([
  'site',
  'sort_by',
  'sort_direction',
  'page_size',
  'suggest',
  'metadata'
])

export const searchFrontendParams = searchCommonParams.concat(['view', 'sort'])

export const searchFrontendFetchParams = searchCommonParams.concat(['sort'])

export const searchFrontendParamsSeoTransform = difference(
  searchFrontendParams,
  ['term']
)

export const searchFrontendLowerCaseParams = [
  'category',
  'tags',
  'term',
  'attribute_key',
  'attribute_value'
]

export const searchApiNonFilterParams = [
  'page',
  'page_size',
  'sort_by',
  'sort_direction',
  'metadata',
  'site'
]

export const searchApiFilterParams = difference(
  searchApiParams,
  searchApiNonFilterParams
)

export const validSortByOptions = [
  'relevance',
  'rating',
  'sales',
  'price',
  'date',
  'updated',
  'category',
  'name',
  'trending',
  'featured_until'
]

export const validSortDirectionOptions = ['asc', 'desc']

export const validDateOptions = [
  'this-year',
  'this-month',
  'this-week',
  'this-day'
]

export const validSizesOptions = ['m', 'l', 'xl', 'xxl']

export const validOrientationOptions = ['landscape', 'portrait', 'square']
